<template>
  <div style="width: 100%; min-height: 100vh; background: rgb(237, 241, 255)">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7" :title="title" left-arrow @click-left="goBack" />
    <div style="height: 46px"></div>
    <div class="gameList">
      <div class="gameLis" v-for="(item, index) in list" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, item.gametype)">
        <img :src="item.gamepic" alt="" />
        <p>{{ item.gamename }}</p>
      </div>
    </div>
    <div v-if="loaded && list.length == 0" style="text-align: center; color: #999; padding: 40px 0; font-size: 13px">暂无游戏</div>
  </div>
</template>
<script>
export default {
  name: 'gamelist',
  data() {
    return { platform: '', cate: '', title: '', list: [], loaded: false };
  },
  created() {
    this.initFromQuery();
  },
  methods: {
    goBack() {
      // 直接回首页，避免历史栈里夹着落地页跳转导致返回失败
      this.$router.replace('/');
    },
    initFromQuery() {
      let that = this;
      let query = that.$route.query;
      that.platform = query.platform || '';
      that.cate = query.cate || '';
      that.title = query.title ? decodeURIComponent(query.title) : '游戏列表';
      that.getSubgames();
    },
    getSubgames() {
      let that = this;
      if (!that.platform || !that.cate) return;
      that.list = [];
      that.loaded = false;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/subgamesByPlatform', { platform_name: that.platform, category_id: that.cate })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.list = res.data || [];
          }
          that.loaded = true;
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.loaded = true;
          that.$parent.hideLoading();
        });
    },
  },
  watch: {
    $route: {
      handler() {
        this.initFromQuery();
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.gameList {
  display: flex;
  flex-wrap: wrap;
  width: 94%;
  margin: 8px auto;
  padding-bottom: 100px;
  .gameLis {
    position: relative;
    width: calc(33.33% - 8px);
    margin-right: 8px;
    margin-top: 8px;
    cursor: pointer;
    img {
      display: block;
      width: 100%;
      border-radius: 10px;
    }
    p {
      text-align: center;
      font-size: 11px;
      color: #555;
      margin: 3px 0 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/gamelist.vue